/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AgentFinalizeIn } from '../models/AgentFinalizeIn';
import type { AgentFinalizeOut } from '../models/AgentFinalizeOut';
import type { AgentTokenIn } from '../models/AgentTokenIn';
import type { AgentTokenOut } from '../models/AgentTokenOut';
import type { AuthConfigOut } from '../models/AuthConfigOut';
import type { CustomerOTPRequestIn } from '../models/CustomerOTPRequestIn';
import type { CustomerOTPResponse } from '../models/CustomerOTPResponse';
import type { CustomerOTPVerifyIn } from '../models/CustomerOTPVerifyIn';
import type { ForgotPasswordIn } from '../models/ForgotPasswordIn';
import type { InvitationAcceptIn } from '../models/InvitationAcceptIn';
import type { InvitationInfoOut } from '../models/InvitationInfoOut';
import type { LoginIn } from '../models/LoginIn';
import type { MapAccessContextOut } from '../models/MapAccessContextOut';
import type { MapAdminAuthorizeIn } from '../models/MapAdminAuthorizeIn';
import type { MapAdminAuthorizeOut } from '../models/MapAdminAuthorizeOut';
import type { MapAdminIntrospectIn } from '../models/MapAdminIntrospectIn';
import type { MapAdminTokenIn } from '../models/MapAdminTokenIn';
import type { MapAdminTokenOut } from '../models/MapAdminTokenOut';
import type { MapAdminUserOut } from '../models/MapAdminUserOut';
import type { MapAuthorizeIn } from '../models/MapAuthorizeIn';
import type { MapAuthorizeOut } from '../models/MapAuthorizeOut';
import type { MapCatalogOperationContext } from '../models/MapCatalogOperationContext';
import type { MapCatalogOperationDecisionOut } from '../models/MapCatalogOperationDecisionOut';
import type { MapEntryOut } from '../models/MapEntryOut';
import type { MapIntrospectIn } from '../models/MapIntrospectIn';
import type { MapOperationContext } from '../models/MapOperationContext';
import type { MapOperationDecisionOut } from '../models/MapOperationDecisionOut';
import type { MapTokenIn } from '../models/MapTokenIn';
import type { MapTokenOut } from '../models/MapTokenOut';
import type { ResetPasswordIn } from '../models/ResetPasswordIn';
import type { UserOut } from '../models/UserOut';
import type { UserSelfPatch } from '../models/UserSelfPatch';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class AuthService {
    /**
     * Agent OAuth Authorize
     * Initiate PKCE browser OAuth authorization flow for local CLI agents.
     * @returns any Successful Response
     * @throws ApiError
     */
    public static agentAuthorizeAuthAgentAuthorizeGet({
        redirectUri,
        state,
        codeChallenge,
        codeChallengeMethod = 'S256',
        label = 'local-agent-key',
    }: {
        redirectUri: string,
        state: string,
        codeChallenge: string,
        codeChallengeMethod?: string,
        label?: string,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/auth/agent/authorize',
            query: {
                'redirect_uri': redirectUri,
                'state': state,
                'code_challenge': codeChallenge,
                'code_challenge_method': codeChallengeMethod,
                'label': label,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Finalize Agent Setup
     * Finalize agent key setup by revoking older keys with the same label.
     * @returns AgentFinalizeOut Successful Response
     * @throws ApiError
     */
    public static agentFinalizeAuthAgentFinalizePost({
        requestBody,
    }: {
        requestBody: AgentFinalizeIn,
    }): CancelablePromise<AgentFinalizeOut> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/auth/agent/finalize',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Exchange Agent Code
     * Exchange PKCE authorization code for raw agent API key and finalize token.
     * @returns AgentTokenOut Successful Response
     * @throws ApiError
     */
    public static agentTokenAuthAgentTokenPost({
        requestBody,
    }: {
        requestBody: AgentTokenIn,
    }): CancelablePromise<AgentTokenOut> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/auth/agent/token',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Callback
     * @returns any Successful Response
     * @throws ApiError
     */
    public static callbackAuthCallbackGet(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/auth/callback',
        });
    }
    /**
     * Auth Config
     * @returns AuthConfigOut Successful Response
     * @throws ApiError
     */
    public static authConfigAuthConfigGet(): CancelablePromise<AuthConfigOut> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/auth/config',
        });
    }
    /**
     * Request Customer Otp
     * @returns CustomerOTPResponse Successful Response
     * @throws ApiError
     */
    public static requestCustomerOtpAuthCustomerOtpRequestPost({
        requestBody,
    }: {
        requestBody: CustomerOTPRequestIn,
    }): CancelablePromise<CustomerOTPResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/auth/customer/otp/request',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Verify Customer Otp
     * @returns UserOut Successful Response
     * @throws ApiError
     */
    public static verifyCustomerOtpAuthCustomerOtpVerifyPost({
        requestBody,
    }: {
        requestBody: CustomerOTPVerifyIn,
    }): CancelablePromise<UserOut> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/auth/customer/otp/verify',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Forgot Password
     * Public. Always returns 204 regardless of whether the email exists —
     * this is the whole point of the endpoint (prevents enumeration). Only
     * users who have already set a password get a reset email; pending
     * invitees do not, since they have no password to reset.
     * @returns void
     * @throws ApiError
     */
    public static forgotPasswordAuthForgotPasswordPost({
        requestBody,
    }: {
        requestBody: ForgotPasswordIn,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/auth/forgot-password',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Login
     * @returns any Successful Response
     * @throws ApiError
     */
    public static loginAuthGoogleGet(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/auth/google',
        });
    }
    /**
     * Invitation Accept
     * Public. Consumes the invitation, sets the user's password, issues
     * auth cookies. 409 if the token is invalid / expired / already used so the
     * SPA can render a single 'this link is no longer valid' state.
     * @returns UserOut Successful Response
     * @throws ApiError
     */
    public static invitationAcceptAuthInvitationAcceptPost({
        requestBody,
    }: {
        requestBody: InvitationAcceptIn,
    }): CancelablePromise<UserOut> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/auth/invitation/accept',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Invitation Info
     * Public. SPA hits this to render 'Welcome, {name}' on the accept-invite
     * page. 404 is used for not-found / expired / already-accepted alike so an
     * attacker can't distinguish between them.
     * @returns InvitationInfoOut Successful Response
     * @throws ApiError
     */
    public static invitationInfoAuthInvitationTokenGet({
        token,
    }: {
        token: string,
    }): CancelablePromise<InvitationInfoOut> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/auth/invitation/{token}',
            path: {
                'token': token,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Login
     * Email+password login. Returns 401 with a single generic message for
     * any failure mode (unknown email, no password set, wrong password) so
     * user enumeration is not possible from the response. A dummy argon2
     * verify runs on the unknown-email path to keep response times uniform.
     * @returns UserOut Successful Response
     * @throws ApiError
     */
    public static loginAuthLoginPost({
        requestBody,
    }: {
        requestBody: LoginIn,
    }): CancelablePromise<UserOut> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/auth/login',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Logout
     * @returns any Successful Response
     * @throws ApiError
     */
    public static logoutAuthLogoutPost(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/auth/logout',
        });
    }
    /**
     * Authorize Map Access
     * @returns MapAuthorizeOut Successful Response
     * @throws ApiError
     */
    public static authorizeMapAccessAuthMapAccessAuthorizePost({
        requestBody,
    }: {
        requestBody: MapAuthorizeIn,
    }): CancelablePromise<MapAuthorizeOut> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/auth/map-access/authorize',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Authorize Map Catalog
     * @returns MapCatalogOperationDecisionOut Successful Response
     * @throws ApiError
     */
    public static authorizeMapCatalogAuthMapAccessAuthorizeCatalogPost({
        requestBody,
        authorization,
    }: {
        requestBody: MapCatalogOperationContext,
        authorization?: (string | null),
    }): CancelablePromise<MapCatalogOperationDecisionOut> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/auth/map-access/authorize-catalog',
            headers: {
                'authorization': authorization,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Authorize Map Operation
     * @returns MapOperationDecisionOut Successful Response
     * @throws ApiError
     */
    public static authorizeMapOperationAuthMapAccessAuthorizeOperationPost({
        requestBody,
        authorization,
    }: {
        requestBody: MapOperationContext,
        authorization?: (string | null),
    }): CancelablePromise<MapOperationDecisionOut> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/auth/map-access/authorize-operation',
            headers: {
                'authorization': authorization,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Map Entry
     * @returns MapEntryOut Successful Response
     * @throws ApiError
     */
    public static mapEntryAuthMapAccessEntryGet({
        customerIdHint,
    }: {
        customerIdHint: string,
    }): CancelablePromise<MapEntryOut> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/auth/map-access/entry',
            query: {
                'customer_id_hint': customerIdHint,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Introspect Map Access
     * @returns MapAccessContextOut Successful Response
     * @throws ApiError
     */
    public static introspectMapAccessAuthMapAccessIntrospectPost({
        requestBody,
        authorization,
    }: {
        requestBody: MapIntrospectIn,
        authorization?: (string | null),
    }): CancelablePromise<MapAccessContextOut> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/auth/map-access/introspect',
            headers: {
                'authorization': authorization,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Exchange Map Access
     * @returns MapTokenOut Successful Response
     * @throws ApiError
     */
    public static exchangeMapAccessAuthMapAccessTokenPost({
        requestBody,
        authorization,
    }: {
        requestBody: MapTokenIn,
        authorization?: (string | null),
    }): CancelablePromise<MapTokenOut> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/auth/map-access/token',
            headers: {
                'authorization': authorization,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Authorize Map Admin
     * @returns MapAdminAuthorizeOut Successful Response
     * @throws ApiError
     */
    public static authorizeMapAdminAuthMapAdminAuthorizePost({
        requestBody,
    }: {
        requestBody: MapAdminAuthorizeIn,
    }): CancelablePromise<MapAdminAuthorizeOut> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/auth/map-admin/authorize',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Introspect Map Admin
     * @returns MapAdminUserOut Successful Response
     * @throws ApiError
     */
    public static introspectMapAdminAuthMapAdminIntrospectPost({
        requestBody,
        authorization,
    }: {
        requestBody: MapAdminIntrospectIn,
        authorization?: (string | null),
    }): CancelablePromise<MapAdminUserOut> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/auth/map-admin/introspect',
            headers: {
                'authorization': authorization,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Exchange Map Admin
     * @returns MapAdminTokenOut Successful Response
     * @throws ApiError
     */
    public static exchangeMapAdminAuthMapAdminTokenPost({
        requestBody,
        authorization,
    }: {
        requestBody: MapAdminTokenIn,
        authorization?: (string | null),
    }): CancelablePromise<MapAdminTokenOut> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/auth/map-admin/token',
            headers: {
                'authorization': authorization,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Me
     * @returns UserOut Successful Response
     * @throws ApiError
     */
    public static meAuthMeGet(): CancelablePromise<UserOut> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/auth/me',
        });
    }
    /**
     * Patch Me
     * Self-service profile patch. Distinct from `PATCH /admin/users/{id}`,
     * which requires admin and edits role. This endpoint only writes the user's
     * display name.
     * @returns UserOut Successful Response
     * @throws ApiError
     */
    public static patchMeAuthMePatch({
        requestBody,
    }: {
        requestBody: UserSelfPatch,
    }): CancelablePromise<UserOut> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/auth/me',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Refresh Endpoint
     * @returns any Successful Response
     * @throws ApiError
     */
    public static refreshEndpointAuthRefreshPost(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/auth/refresh',
        });
    }
    /**
     * Reset Password
     * Public. Consume a reset token and set a new password. Revokes all
     * existing refresh tokens for the user so any stolen sessions die. Does
     * NOT issue fresh cookies — the user has to log in explicitly, which also
     * doubles as a sanity check that the new password works.
     * @returns void
     * @throws ApiError
     */
    public static resetPasswordAuthResetPasswordPost({
        requestBody,
    }: {
        requestBody: ResetPasswordIn,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/auth/reset-password',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
